/*------------------------------------*\
    helpers
\*------------------------------------*/
module.exports = function(){



    window.eph = {};






    /*------------------------------------*\
        add item to wishlist
    \*------------------------------------*/

    window.eph.addItemToWishlist = function(productId, success, error){
        var action = EPH_API_URL + '/wa-customers/' + globalCustomerId + '/addToWishlist/' + productId;
        var self = this;
        $.ajax({
            url: action,
            type: 'POST',
            dataType: 'json',
            headers: {
                Authorization: 'Bearer ' + Cookies.get('JWT_ACCESS_TOKEN'),
                Accept: 'application/json'
            },
            complete: function(jqXHR, textStatus){
            },
            success: function(data, textStatus, jqXHR){
                success ? success(data, textStatus, jqXHR) : null;
            },
            error: function(jqXHR, textStatus, errorThrown){
                error ? error(jqXHR, textStatus, errorThrown) : null;
            },
        });

    };




    /*------------------------------------*\
        delete item from wishlist
    \*------------------------------------*/
    window.eph.deleteItemFromWishlist = function(productId, success){


        if (typeof globalCustomerId === 'undefined') {
            return false;
        }


        //https://eph-wa.d3.dashagencydev.com/api/v1/wa-customers/wa_customer_id/removeFromWishlist/wa_web_product_id

        $.ajax({
            url: EPH_API_URL + '/wa-customers/' + globalCustomerId + '/removeFromWishlist/' + productId,
            type: 'POST',
            dataType: 'json',
            headers: {
                Authorization: 'Bearer ' + Cookies.get('JWT_ACCESS_TOKEN'),
                Accept: 'application/json'
            },
            complete: function(jqXHR, textStatus){

            },
            success: function(data, textStatus, jqXHR){

                success.apply(this, [data]);

            },
            error: function(jqXHR, textStatus, errorThrown){

            },

        });


    };
























    /*------------------------------------*\
        get single product
    \*------------------------------------*/
    window.eph.getSingleProduct = function(productId, customizations, backendCartId, uid, success){



        $.ajax({
            url: EPH_API_URL + '/wa-webProducts/' + productId + '?ephCountry=' + ephGlobals.country,
            type: 'GET',
            dataType: 'json',
            complete: function(jqXHR, textStatus){

            },
            success: function(data, textStatus, jqXHR){

                //console.log(data);

                var onSale = false;
                var squarePriceExists = data.product.square_price;

                if (squarePriceExists) {
                    var squarePrice = data.product.square_price;
                    var roundedSquarePrice = parseFloat(squarePrice).toFixed(2);
                }

                var salePriceExists = data.product.square_has_sale;

                if (salePriceExists) {
                    var salePrice = data.product.square_sale_price;
                    var roundedSalePrice = parseFloat(salePrice).toFixed(2);
                    //console.log(roundedSalePrice);
                    onSale = true;
                }


                if (data.web_product_auto_discount && (data.web_product_auto_discount != ' + 0') ) {
                    var roundedSalePrice = eval('squarePrice ' + data.web_product_auto_discount);
                    /* eval('var roundedSalePrice = squarePrice ' + data.web_product_auto_discount + ';'); */
                    var roundedSalePrice = parseFloat(roundedSalePrice).toFixed(2);

                    salePriceExists = true;
                    onSale = true;
                }


                var templateData = {
                    id: data.wa_web_product.Id,
                    uid: uid,
                    url: WP_SITEURL + '/product/' + data.wa_web_product.Meta.Slug,
                    name: data.MetaTitle,
                    imgSrc: function(){

                        //OLD: OMS_CDN + '/Images/products/' + data.Id + '/feature.jpg',

                        if ( (data.wa_web_product.images).length ) {
                            return EPH_S3_CDN + data.wa_web_product.images[0].FilePath + '/' + data.wa_web_product.images[0].FileName;
                        } else {
                            return WP_SITEURL + '/wp-content/themes/eph-apparel/static/img/placeholder/product-feature.jpg';
                        }

                    },
                    customizations: customizations,

                    onSale: onSale,
                    squarePriceExists: squarePriceExists,
                    salePriceExists: salePriceExists,
                    roundedSquarePrice: roundedSquarePrice,
                    roundedSalePrice: roundedSalePrice,
                };


                let totalOptionCost = 0;
                customizations.forEach(function(option, index) {
                    if (option.optionCost) {
                        totalOptionCost += parseFloat(option.optionCost);
                        console.log('totalOptionCost +=', option.optionCost);
                    }
                });

                console.log('templateData', templateData);
                console.log('totalOptionCost =', totalOptionCost);

                if (totalOptionCost && totalOptionCost > 0) {
                    templateData.totalOptionCost = totalOptionCost.toFixed(2);
                }

                if (backendCartId) {
                    templateData.backendCartId = backendCartId;
                }

                if (success) {
                    success.apply(this, [templateData]);
                }


                $(window).trigger('singleproductloaded');




            },
            error: function(jqXHR, textStatus, errorThrown){

            },

        });

    };






    /*------------------------------------*\
        login user
    \*------------------------------------*/
    window.eph.loginUser = function(email, password){

        var action = EPH_API_URL + '/customers/auth/login';

        $.ajax({
            url: action,
            type: 'POST',
            data: { Email:email, password:password },
            dataType: 'json',

            complete: function(jqXHR, textStatus){

            },

            success: function(data, textStatus, jqXHR){

                //console.log(data.data.token);
                Cookies.set('JWT_ACCESS_TOKEN', data.data.token, { expires: 90 });

            },

            error: function(jqXHR, textStatus, errorThrown){

            },

        });

    };



    /*------------------------------------*\
        get user wishlist
    \*------------------------------------*/
    window.eph.getUserWishlist = function(options){

        if (typeof globalCustomerId === 'undefined') {
            return false;
        }

        var action = EPH_API_URL + '/wa-customers/' + globalCustomerId + '/wishlist/';

        $.ajax({
            url: action,
            type: 'GET',
            dataType: 'json',
            headers: {
                Authorization: 'Bearer ' + Cookies.get('JWT_ACCESS_TOKEN'),
                Accept: 'application/json'
            },
            complete: function(jqXHR, textStatus){
                options.complete ? options.complete.call(this, jqXHR, textStatus) : null;
            },
            success: function(data, textStatus, jqXHR){
                options.success ? options.success.call(this, data, textStatus, jqXHR) : null;
            },
            error: function(jqXHR, textStatus, errorThrown){
                options.error ? options.error.call(this, jqXHR, textStatus, errorThrown) : null;
            },
        });


    };


    /*------------------------------------*\
        get customer id
    \*------------------------------------*/
    window.eph.getCustomerId = function(callback){


        $.ajax({
            url: EPH_API_URL + '/customers/auth/get',
            type: 'GET',
            dataType: 'json',
            headers: {
                Authorization: 'Bearer ' + Cookies.get('JWT_ACCESS_TOKEN'),
                Accept: 'application/json'
            },
            success: function(output){

                callback(output.Id, output);

            }
        });

    };



    /*------------------------------------*\
        get customer measurement
    \*------------------------------------*/
    window.eph.getCustomerMeasurement = function(measurementId){

        var action = EPH_API_URL + '/customerMeasurements/' + measurementId;

        $.ajax({
            url: action,
            type: 'GET',
            dataType: 'json',
            headers: {
                Authorization: 'Bearer ' + Cookies.get('JWT_ACCESS_TOKEN'),
                Accept: 'application/json'
            },

            complete: function(jqXHR, textStatus){

            },

            success: function(data, textStatus, jqXHR){

            },

            error: function(jqXHR, textStatus, errorThrown){

            },
        });

    };



    /*------------------------------------*\
        patch customer measurement
    \*------------------------------------*/
    window.eph.patchCustomerMeasurement = function(measurementTypeId, measurementValueId, value, callback){

        var action = EPH_API_URL + '/customerMeasurements/' + measurementValueId;


        var requestData = {
                //CustomerMeasurementProfileId: parseInt( measurementValueId ),
                MeasurementTypeId: parseInt( measurementTypeId ),
                Value: String( value ),
                '_method': 'PATCH'
        };

        $.ajax({
            url: action,
            type: 'PATCH',
            dataType: 'json',
            data: requestData,
            headers: {
                Authorization: 'Bearer ' + Cookies.get('JWT_ACCESS_TOKEN'),
                Accept: 'application/json'
            },

            complete: function(jqXHR, textStatus){
                //if (callback) { callback.apply(this, [jqXHR, textStatus]); }
            },

            success: function(data, textStatus, jqXHR){
                if (callback) { callback.apply(this, [data, textStatus, jqXHR]); }
            },

            error: function(jqXHR, textStatus, errorThrown){
                if (callback) { callback.apply(this, [jqXHR, textStatus, errorThrown]); }
            },

        });

    };







    /*------------------------------------*\
        patch customer measurement
    \*------------------------------------*/
    window.eph.deleteCustomerMeasurement = function(measurementValueId, callback){

        var action = EPH_API_URL + '/customerMeasurements/' + measurementValueId;

        var requestData = {
                '_method': 'DELETE'
        };

        $.ajax({
            url: action,
            type: 'DELETE',
            dataType: 'json',
            data: requestData,
            headers: {
                Authorization: 'Bearer ' + Cookies.get('JWT_ACCESS_TOKEN'),
                Accept: 'application/json'
            },

            complete: function(jqXHR, textStatus){

                //if (callback) {
                //    callback.apply(this, [data, textStatus, jqXHR]);
                //}

            },

            success: function(data, textStatus, jqXHR){

                if (callback) {
                    callback.apply(this, [data, textStatus, jqXHR]);
                }

            },

            error: function(jqXHR, textStatus, errorThrown){

                if (callback) {
                    callback.apply(this, [data, textStatus, jqXHR]);
                }

            },
        });

    };










    window.eph.getMeasurementProfilesOfUser = function(){

        if (typeof globalCustomerId === 'undefined') {
            return false;
        }

        $.ajax({
            url: EPH_API_URL + '/wa-customers/' + globalCustomerId + '/measurementProfiles',
            type: 'GET',
            dataType: 'json',
            headers: {
                Authorization: 'Bearer ' + Cookies.get('JWT_ACCESS_TOKEN')
            },

            complete: function(jqXHR, textStatus){
                //console.log(jqXHR);
            },

            success: function(data, textStatus, jqXHR){
            },

            error: function(jqXHR, textStatus, errorThrown){

            },

        });



    };



    /*------------------------------------*\
        tagGetFittedCustomer
    \*------------------------------------*/
    window.eph.tagGetFittedCustomer = function(CustomerId){

        var action = EPH_API_URL + '/wa-fashion-metric/tag/' + CustomerId;

        $.ajax({
            url: action,
            type: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Cookies.get('JWT_ACCESS_TOKEN'),
            },
            data: {CustomerId:CustomerId},
            dataType: 'json',

            complete: function(jqXHR, textStatus){

            },

            success: function(data, textStatus, jqXHR){

                Cookies.remove('FM_EPH_CONVERSION_ID')
                console.log(data.data);

            },

            error: function(jqXHR, textStatus, errorThrown){

            },

        });

    };



    window.eph.createMeasurementProfile = function(options){

        var requestData = {
            CustomerId: options.CustomerId,
            Name: options.Name,
            BodyTypeShoulderId: 1,
            BodyTypePostureId: 2,
            BodyTypeChestId: 3,
        };

        if (options.IsFm) {
            requestData.IsFm = options.IsFm;
        }

        return $.ajax({
            url: EPH_API_URL + '/customerMeasurementProfiles',
            type: 'POST',
            dataType: 'json',
            data: requestData,
            complete: function(jqXHR, textStatus){
                options.complete ? options.complete.call(this, jqXHR, textStatus) : null;
            },
            success: function(data, textStatus, jqXHR){
                options.success ? options.success.call(this, data, textStatus, jqXHR) : null;
            },
            error: function(jqXHR, textStatus, errorThrown){
                options.error ? options.error.call(this, jqXHR, textStatus, errorThrown) : null;
            },
        });

    };






    window.eph.createMeasurement = function(profileId, measurementId, value){

        var requestData = {
          CustomerMeasurementProfileId: profileId,
          MeasurementTypeId: measurementId,
          Value: value
        };


        $.ajax({
            url: EPH_API_URL + '/customerMeasurements',
            type: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + Cookies.get('JWT_ACCESS_TOKEN'),
            },
            dataType: 'json',
            data: requestData,

            complete: function(jqXHR, textStatus){
                //console.log(jqXHR);
            },

            success: function(data, textStatus, jqXHR){
            },

            error: function(jqXHR, textStatus, errorThrown){

            },

        });




    };







//https://eph-wa.d3.dashagencydev.com/api/v1/customerMeasurementProfiles

/*
{
  "CustomerId": 1,
  "Name": "Shirt - Feb 2014",
  "BodyTypeShoulderId": 1,
  "BodyTypePostureId": 2,
  "BodyTypeChestId": 3
}
*/




//https://eph-wa.d3.dashagencydev.com/api/v1/customerMeasurements

/*
{
  "CustomerMeasurementProfileId": 1,
  "MeasurementTypeId": 1,
  "Value": "5"
}
*/







    /*------------------------------------*\
        WACustomer Meta Set
    \*------------------------------------*/
    window.eph.setSameAddress = function(options){

        if (typeof globalCustomerId === 'undefined') {
            return false;
        }


        // WACustomers Meta Set (POST https://eph-wa.d3.dashagencydev.com/api/v1/wa-customers/94/meta)

        jQuery.ajax({
            url: EPH_API_URL + '/wa-customers/' + globalCustomerId + '/meta',
            type: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Cookies.get('JWT_ACCESS_TOKEN'),
            },
            contentType: 'application/json',
            data: JSON.stringify([
                {
                    'Key': 'SameAddress',
                    'Value': options.value,
                }
            ]),

            complete: function(jqXHR, textStatus){
                options.complete ? options.complete.call(this, jqXHR, textStatus) : null;
            },
            success: function(data, textStatus, jqXHR){
                options.success ? options.success.call(this, data, textStatus, jqXHR) : null;
            },
            error: function(jqXHR, textStatus, errorThrown){
                options.error ? options.error.call(this, jqXHR, textStatus, errorThrown) : null;
            },

        });



    };






    /*------------------------------------*\
        WACustomer Meta Set
    \*------------------------------------*/
    window.eph.getSameAddress = function(options){

        if (typeof globalCustomerId === 'undefined') {
            return false;
        }


        // WACustomers Meta Get (GET https://eph-wa.d3.dashagencydev.com/api/v1/wa-customers/94/meta)

        jQuery.ajax({
            url: EPH_API_URL + '/wa-customers/' + globalCustomerId + '/meta',
            type: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Cookies.get('JWT_ACCESS_TOKEN'),
            },
            contentType: 'application/json',
            complete: function(jqXHR, textStatus){
                options.complete ? options.complete.call(this, jqXHR, textStatus) : null;
            },
            success: function(data, textStatus, jqXHR){
                options.success ? options.success.call(this, data, textStatus, jqXHR) : null;
            },
            error: function(jqXHR, textStatus, errorThrown){
                options.error ? options.error.call(this, jqXHR, textStatus, errorThrown) : null;
            },
        });



    };




















































    window.eph.customizeOrder = function(requestData, orderId, success, error, complete){
        $.ajax({
            url: EPH_API_URL + '/wa-customers/' + globalCustomerId + '/customizeOrder/' + orderId,
            type: 'POST',
            dataType: 'json',
            headers: {
                Authorization: 'Bearer ' + Cookies.get('JWT_ACCESS_TOKEN'),
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            data: requestData,
            complete: function(jqXHR, textStatus){
                complete ? complete.call(this, jqXHR, textStatus) : false;
            },
            success: function(data, textStatus, jqXHR){
                success ? success.call(this, data, textStatus, jqXHR) : false;
            },
            error: function(jqXHR, textStatus, errorThrown){
                error ? error.call(this, jqXHR, textStatus, errorThrown) : false;
                ((typeof window.Bugsnag) != 'undefined') && window.Bugsnag.notify("customizeOrderError", "customizeOrder", {
                    "requestUrl": EPH_API_URL + '/wa-customers/' + globalCustomerId + '/customizeOrder/' + orderId,
                    "requestData": requestData,
                    "response": {
                        "readyState": jqXHR.readyState,
                        "responseJSON": jqXHR.responseJSON,
                        "responseText": jqXHR.responseText,
                        "statusCode": jqXHR.statusCode,
                        "statusText": jqXHR.statusText
                    }
                })
            },
        });
    };
















    /*------------------------------------*\
        add product to backend cart
    \*------------------------------------*/
    /*
    window.eph.addProductToBackendCart = function(productId, customizations, success){

        if (typeof globalCustomerId === 'undefined') {
            return false;
        }

        var action = EPH_API_URL + '/wa-customers/' + globalCustomerId + '/cart/add-item/' + productId;


        if (customizations && (customizations.length > 0)) {
            var customizationOptions = JSON.stringify( customizations );
        } else {
            var customizationOptions = JSON.stringify('[]');
        }


        var requestData = {
            quantity: 1,
            customization_options: customizationOptions,
        };

        //console.log(requestData);

        $.ajax({
            url: action,
            type: 'POST',
            dataType: 'json',
            data: requestData,
            headers: {
                Authorization: 'Bearer ' + Cookies.get('JWT_ACCESS_TOKEN'),
                Accept: 'application/json'
            },

            complete: function(jqXHR, textStatus){

            },

            success: function(data, textStatus, jqXHR){
                if (success) {
                    success.apply(this, [data, textStatus, jqXHR]);
                }
            },

            error: function(jqXHR, textStatus, errorThrown){

            },
        });



        */
        /*
        var requestDataPlaceholder = {
            quantity: 1,
            customization_options: JSON.stringify({
                CustomizationGroup: 'Shirt Options',
                CustomizationType: 'Fit',
                CustomizationOptionId: 20,
                Value: {
                    Id: 39,
                    OMSName: 'Modern',
                    Name: 'Modern',
                    Description: 'Modern',
                    Value: null,
                    Selected: true,
                    Images: [
                        {
                            Id: 34,
                            ImageTypeId: 12,
                            FilePath: '/Images/Customizations',
                            FileName: 'shirt_modern.jpg',
                            AltText: 'EPH Apparel Customization',
                            Width: 110,
                            Height: 110,
                            FileSource: '../Images/Customizations/shirt_modern.jpg',
                            ThumbnailId: 'modern'
                        }
                    ]
                }
            }),
        };



        var requestDataPlaceholderAlt = {
            quantity: 1,
            customization_options: JSON.stringify({
                TypeId: 15,
                Value: 'Some Value',
            }),
        };

        */
        /*



    };
    */






    /*------------------------------------*\
        remove product from backend cart
    \*------------------------------------*/
    /*
    window.eph.removeProductFromBackendCart = function(productId, success){

        if (typeof globalCustomerId === 'undefined') {
            return false;
        }

        //https://eph-wa.d3.dashagencydev.com/api/v1/wa-customers/wa_customer_id/cart/remove-item/wa_web_product_id

        var action = EPH_API_URL + '/wa-customers/' + globalCustomerId + '/cart/remove-item/' + productId;


        $.ajax({
            url: action,
            type: 'POST',
            dataType: 'json',
            headers: {
                Authorization: 'Bearer ' + Cookies.get('JWT_ACCESS_TOKEN'),
                Accept: 'application/json'
            },

            complete: function(jqXHR, textStatus){

            },

            success: function(data, textStatus, jqXHR){
                if (success) {
                    success.apply(this, [data, textStatus, jqXHR]);
                }
            },

            error: function(jqXHR, textStatus, errorThrown){

            },
        });



    };
    */






    /*------------------------------------*\
        get cart item
    \*------------------------------------*/
    window.eph.getBackendCartItems = function(success, error){

        if (typeof globalCustomerId === 'undefined') {
            return false;
        }

        var action = EPH_API_URL + '/wa-customers/' + globalCustomerId + '/cart/list-items';

        $.ajax({
            url: action,
            type: 'GET',
            dataType: 'json',
            headers: {
                Authorization: 'Bearer ' + Cookies.get('JWT_ACCESS_TOKEN'),
                Accept: 'application/json'
            },

            complete: function(jqXHR, textStatus){
                //if (callback) { callback.apply(this, [jqXHR, textStatus]); }
            },

            success: function(data, textStatus, jqXHR){
                window.cartBackend = data;
                if (success) { success.apply(this, [data, textStatus, jqXHR]); }
                console.info('cartBackend retrieved', window.cartBackend);
            },

            error: function(jqXHR, textStatus, errorThrown){
                if (error) { error.apply(this, [jqXHR, textStatus, errorThrown]); }
            },

        });

    };




}; // end of module.exports




// WEBPACK FOOTER //
// ./js-source/integration/eph-ajax.js